<template>
    <div class="more-menu-page d-flex flex-wrap">
        <div class="user-profile-bar">
            <strong v-if="user.name">{{ user.name }} &middot;</strong> {{ user.email }}
        </div>
        <ul class="more-navigation mb-auto">
            <li>
                <router-link to="/categories">
                    <i class="fas fa-fw fa-list"></i> <span>{{ $t('Категории') }}</span>
                </router-link>
            </li>
            <li>
                <router-link to="/budget">
                    <i class="fas fa-fw fa-columns"></i> <span>{{ $t('Бюджет') }}</span>
                </router-link>
            </li>
            <li>
                <router-link to="/accounts">
                    <i class="fas fa-fw fa-file-invoice"></i> <span>{{ $t('Счета') }}</span>
                </router-link>
            </li>
            <li>
                <router-link to="/reminders">
                    <i class="fas fa-fw fa-bell"></i> <span>{{ $t('Напоминания') }}</span>
                </router-link>
            </li>
            <li>
                <router-link to="/settings">
                    <i class="fas fa-fw fa-cog"></i> <span>{{ $t('Настройки') }}</span>
                </router-link>
            </li>
        </ul>

        <ul class="more-navigation footer-menu">
            <li>
                <router-link to="/help">
                    <i class="fas fa-fw fa-life-ring"></i> <span>{{ $t('Помощь') }}</span>
                </router-link>
            </li>
            <li>
                <a href="#" @click.prevent="logout">
                    <i class="fas fa-fw fa-sign-out-alt"></i> <span>{{ $t('Выход') }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['user']),
    },

    methods: {
        logout() {
            return;

            axios.post('/logout')
                .then(({data}) => {
                    this.$store.commit('logout');
                    
                    localStorage.removeItem('token');

                    delete axios.defaults.headers.common['Authorization'];

                    location.href = '/login';
                }).catch((error) => {
                    console.log(error);
                });
        },
    },
}
</script>

<style lang="scss">
.more-menu-page {
    height: 100%;
    flex-direction: column;
}

.user-profile-bar {
    padding: 10px 15px;
    width: 100%;
    background: #fff;
    box-shadow: -20px 0px 50px rgba(0, 0, 0, 0.15);
    max-height: 44px;
}

.more-navigation {
    padding: 0;
    margin: 0;
    list-style: none;
    width: 250px;
    width: 100%;

    &.mb-100 {
        margin-bottom: 100%;
    }

    &.mb-95 {
        margin-bottom: 95%;
    }

    &.footer-menu {
        /* iphone X , XS, 11 Pro */
        @media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (-webkit-device-pixel-ratio: 3) { padding-bottom: 25px; }

        /* iphone XR, 11 */
        @media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 2) { padding-bottom: 25px; }

        /* iphone XS Max, 11 Pro Max */
        @media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 3) { padding-bottom: 25px; }
    }

    li {
        width: 100%;
        margin: 3px 0;

        a {
            color: #495057;
            text-decoration: none;
            font-weight: 500;
            padding: 15px 21px;
            display: block;
            border-radius: 5px;

            &.router-link-exact-active {
                background: #F5F8FE;
                color: #336EBD;
            }

            .fas {
                margin-right: 16px;
            }
        }
    }
}
</style>